"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArrayMetadataWithIndex = buildArrayMetadataWithIndex;
function buildArrayMetadataWithIndex(newMetadata, index) {
    return (arrayMetadata) => {
        arrayMetadata[index] = newMetadata;
        return arrayMetadata;
    };
}
//# sourceMappingURL=buildArrayMetadataWithIndex.js.map